export default __webpack_public_path__ + "static/media/standupkids.9acb88ee.jpg";